import styled from 'styled-components/macro';
import { colorCoreBlack900Base, colorBlackTransparent50 } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { FlexWrapper } from '@yme/tokens/flexTokens';
export const ItemPillStyled = styled(FlexWrapper) `
  box-sizing: border-box;

  padding: ${({ isRightToLeft }) => (isRightToLeft ? '4px 12px 4px 4px' : '4px 4px 4px 12px')};

  border: 1px solid ${colorCoreBlack900Base};

  border-radius: ${CORNER_RADIUS.xxl};

  &:hover {
    background-color: ${colorBlackTransparent50};

    & > span {
      cursor: pointer;
    }
  }

  & > a {
    text-decoration: none;
    cursor: default;
  }
`;
